import { Dropdown, Typography } from "antd";
import { memo, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  useGetColorGradientQuery,
  useUpdateColorGradientMutation,
} from "../../service/apiSlices/workbench";
import { showErrorToast, showSuccessToast } from "../../utilities/toastUtils";
import { useColorContext } from "../../context/workbench/ColorContext";
import { useSelector } from "react-redux";
import { RootState } from "../../service/store";
import downIcon from "../../assets/icons/chevron-down.svg";

const ViewPortThemeChanger = () => {
  const { t } = useTranslation("common");
  const workBenchName = useSelector(
    (state: RootState) => state?.static?.workBenchName
  );
  const colorContext = useColorContext();
  const secret_key = sessionStorage.getItem('secret_key');

  const [bgColor, setBgColor] = useState("gray");

  const { data: colorGradientData, refetch } = useGetColorGradientQuery(secret_key);
  const [updateColorGradient] = useUpdateColorGradientMutation();

  const items = useMemo(
    () => [
      {
        key: "1",
        label: t("workbench.colors.gray"),
        onClick: () => {
          let payload = {
            secret_key: secret_key,
            data: {
              bg_colour: "gray",
              bg_code: "",
            },
          };
          updateColorGradient(payload)
            .unwrap()
            .then((response: any) => {
              if (response?.status_code === 200) {
                showSuccessToast(response.message);
                refetch();
              } else {
                showErrorToast(response.message);
              }
            })
            .catch((error: any) => {
              showErrorToast("Failed to change color");
            });
        },
        icon: <div className="circle gray" />,
      },
      {
        key: "2",
        label: t("workbench.colors.green"),
        onClick: () => {
          let payload = {
            secret_key: secret_key,
            data: {
              bg_colour: "green",
              bg_code: "",
            },
          };
          updateColorGradient(payload)
            .unwrap()
            .then((response: any) => {
              if (response?.status_code === 200) {
                showSuccessToast(response.message);
                refetch();
              } else {
                showErrorToast(response.message);
              }
            })
            .catch((error: any) => {
              showErrorToast("Failed to change color");
            });
        },
        icon: <div className="circle green" />,
      },
    ],
    [refetch, secret_key, t, updateColorGradient]
  );

  useEffect(() => {
    if (colorGradientData?.data?.colour_name) {
      setBgColor(colorGradientData?.data?.colour_name);
      colorContext?.getColor(colorGradientData?.data?.colour_name);
    }
  }, [colorGradientData?.data?.colour_name, colorContext]);

  return (
    <Dropdown
      menu={{ items }}
      disabled={workBenchName === ""}
      openClassName="dd-open"
      className="color-dd"
    >
      <div className="d-flex align-items-center">
        <span className="color-section-child">
          <Typography className="color-font">{t("workbench.color")}</Typography>
          <div className={`circle ${bgColor}`} />
        </span>
        <img src={downIcon} alt="down" className="color-dd-icon" />
      </div>
    </Dropdown>
  );
};

export default memo(ViewPortThemeChanger);
